import React from 'react';
import { MessageCircle, Sparkles } from 'lucide-react';

export default function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#0d1117]">
      <div className="flex flex-col items-center max-w-md px-8 animate-in fade-in duration-500">
        {/* Icon Container with Glow */}
        <div className="relative mb-8">
          {/* Background Glow */}
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl rounded-full" />

          {/* Icon */}
          <div className="relative bg-gradient-to-br from-cyan-600 to-blue-700 p-6 rounded-2xl
                        shadow-2xl shadow-cyan-500/30 transform hover:scale-105 transition-transform">
            <MessageCircle className="w-16 h-16 text-white" strokeWidth={1.5} />

            {/* Sparkle Decoration */}
            <div className="absolute -top-2 -right-2">
              <Sparkles className="w-6 h-6 text-cyan-400 animate-pulse" />
            </div>
          </div>
        </div>

        {/* Text Content */}
        <h2 className="text-2xl font-bold text-gray-200 mb-3 text-center">
          No conversation selected
        </h2>
        <p className="text-gray-500 text-center text-sm leading-relaxed">
          Select a conversation from the list to view messages and start chatting
        </p>

        {/* Decorative Separator */}
        <div className="flex items-center gap-2 mt-8 opacity-50">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-gray-700" />
          <MessageCircle className="w-3 h-3 text-gray-700" />
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-gray-700" />
        </div>
      </div>
    </div>
  );
}
